module.exports = __webpack_public_path__ + "img/imgridtipimg.e65d2de9.png";